﻿export default class ProductCarousel {
    root;
     membersDiscountText;
    discountText;

    constructor(element) {
        this.root = element;
        this.membersDiscountText = this.root?.dataset.membersDiscountText;
        this.discountText = this.root?.dataset.discountText;
        this.init();
    }

    init = () => {
        this.initProductCarousel();
        this.initDiscountTexts();
    };

    initProductCarousel = () => {
        if (!this.root) return;

         if ($('._js_product-carousel').length) {
            $('._js_product-carousel').slick({
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                adaptiveHeight: true,
                adaptiveWidth: true,
                infinite: true,
            });
        }
    };

    initDiscountTexts = () => {
        if (!this.root || (!this.membersDiscountText && !this.discountText)) return;

        const labelContainer = document.createElement('div');
        labelContainer.className = 'label__container';

        if (this.membersDiscountText) {
            const memberDiscountLabel = document.createElement('span');
            memberDiscountLabel.className = 'label A label--amountdiscount';
            memberDiscountLabel.textContent = this.membersDiscountText;
            labelContainer.appendChild(memberDiscountLabel);
        }

        if (this.discountText) {
            const discountLabel = document.createElement('span');
            discountLabel.className = 'label B label--amountdiscount';
            discountLabel.textContent = this.discountText;
            labelContainer.appendChild(discountLabel);
        }

        this.root.appendChild(labelContainer);
    };
}
